// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".comment_textarea_bottom-Q6VjSFdG {\n    font-size: 12px;\n}\n\n.userinfo-3a_B4B7x {\n    color: #000;\n    text-decoration: none;\n}\n\n.account-38naG5Cf {\n    cursor: pointer;\n    color: #999 !important\n}\n\n.account-38naG5Cf:hover {\n    color: #999;\n}\n\n.line-1AFuXO4f {\n    padding: 0 2px;\n    color: #999;\n}\n", ""]);
// Exports
exports.locals = {
	"comment_textarea_bottom": "comment_textarea_bottom-Q6VjSFdG",
	"userinfo": "userinfo-3a_B4B7x",
	"account": "account-38naG5Cf",
	"line": "line-1AFuXO4f"
};
module.exports = exports;
